import React, { memo } from 'react';
import ReactQuill from 'react-quill';
import { formatsQuill, modulesQuill } from '@constants/reactQuill';
import { FormControl, FormLabel } from '@material-ui/core/';
import { ClassNameMap } from '@material-ui/styles';
import { FormLabelClassKey } from '@material-ui/core';

import 'react-quill/dist/quill.snow.css';
import './index.scss';
import './quillSettings';
interface IRichTextEditorProps {
  value: string;
  onChange: (value: string, index?: number, key?: number) => void;
  className?: string;
  onFocus?: (selection: unknown) => void;
  label?: string;
  labelClasses?: Partial<ClassNameMap<FormLabelClassKey>>;
  testId?: string;
  index?: number;
  schema?: any;
  isMultipleGroupElement?: boolean;
}
const RichTextEditorFormField = memo(
  ({
    value,
    onChange,
    className,
    onFocus,
    label,
    labelClasses,
    testId,
    index,
    schema,
    isMultipleGroupElement,
  }: IRichTextEditorProps) => {
    const handleTextChange = (newValue: string, _, source: string) => {
      if (source === 'user') {
        if (newValue !== value) {
          return isMultipleGroupElement
            ? onChange(newValue, index, schema.key)
            : onChange(newValue);
        }
      }
    };

    return (
      <FormControl variant="standard" fullWidth data-testid={testId}>
        <FormLabel classes={labelClasses}>{label}</FormLabel>
        <ReactQuill
          theme="snow"
          modules={modulesQuill}
          formats={formatsQuill}
          value={value}
          className={className}
          onChange={handleTextChange}
          onFocus={onFocus}
        />
      </FormControl>
    );
  }
);

export default RichTextEditorFormField;
